<template>
  <div>
    <article
      class="cursor-pointer mx-auto px-4 my-12 w-full max-w-sm sm:w-96 sm:max-w-none md:mx-3 flex items-center"
      @click="showSpeakerModal(speaker)"
    >
      <div class="w-32 h-32 flex-shrink-0">
        <img
          :src="speaker.image_url"
          :alt="speaker.full_name"
          class="w-full rounded-full"
        />
      </div>
      <div class="text-left pl-8 flex-gr">
        <h4 class="font-bold transition-all duration-200">
          {{ speaker.full_name }}
        </h4>
        <p>{{ speaker.position }}</p>
        <p>{{ speaker.company }}</p>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  props: {
    speaker: {
      type: Object,
      required: true,
    },
  },

  methods: {
    showSpeakerModal(speaker) {
      this.$store.commit('speakers/setCurrentSpeaker', speaker)
      this.$store.commit('speakers/setShowSpeakerModal', true)
    },
  },
}
</script>

<style scoped>
article:hover h4 {
  @apply text-secondary-500;
}
</style>
